const LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
const LOCAL_STORAGE_DELIMITER = ",";
const BUTTON_ACTIVE_CLASS = "active";
const GRID_LOADED_CLASS = "loaded";
const CUSTOMER_LOGGED_IN = window.customer?.isLoggedIn;
const CUSTOMER_ID = window.customer?.id;

// dynamically get store name
const storeURLParts = window.Shopify?.shop.split(".");
const store = storeURLParts.length ? storeURLParts[0] : undefined;

const ALL_WISHLIST_URL = CUSTOMER_ID
  ? `https://netlify.blacklemon.dk/.netlify/functions/getCustomerWishlistProducts?store=${store}&customerId=${CUSTOMER_ID}`
  : "";
const UPDATE_WISHLIST_URL = CUSTOMER_ID
  ? `https://netlify.blacklemon.dk/.netlify/functions/updateCustomerWishlist?store=${store}&customerId=${CUSTOMER_ID}`
  : "";
const selectors = {
  button: "[button-wishlist]",
  buttonNotInitialized: "[button-wishlist]:not([data-initialized])",
  grid: "[grid-wishlist]",
  wishlistEmpty: ".wishlist__empty",
  wishlistContent: ".wishlist__grid",
  wishlistText: ".wishlist__text",
  productCard: ".ProductItem",
  productCardImageWrapper: ".ProductItem__ImageWrapper",
  productRecommendation: "#shopify-section-product-recommendations",
  exportBtn: ".btn-wishlist-export",
};

(function () {
  async function loadAllProducts() {
    const templateSuffix = "json-bb";
    const collectionHandle = "all-products";

    const allProducts = [];
    let page = 1;
    let hasMoreProducts = true;

    let loopCount = 0;

    while (hasMoreProducts && loopCount < 10) {
      loopCount++;

      try {
        const response = await fetch(`/collections/${collectionHandle}?view=${templateSuffix}&page=${page}`, {
          type: "GET",
        });
  
        const json = await response.json();
  
        if (json.products.length > 0) {
          allProducts.push(...json.products);
          page++;
        } else {
          hasMoreProducts = false;
        }
        
      } catch (error) {
        hasMoreProducts = false;
      }
    }

    window.ALL_VARIANTS = allProducts;
  }

  if (Shopify.b2bEnabled) {
    loadAllProducts().then(() => {

      setTimeout(() => {
        const exportBtn = document.querySelector(selectors.exportBtn);
        if (exportBtn) {
          exportBtn.classList.remove("hidden");
        }
        const event = new CustomEvent("shopify-wishlist:variants-loaded", {
          detail: {},
        });

        document.dispatchEvent(event);
      }, 500);
      
    });
  }
  })();

document.addEventListener("DOMContentLoaded", () => {
  initButtons();
  initGrid();
  if (CUSTOMER_LOGGED_IN) {
    updateMergedWishlist();
  }
  updateHeaderIcon();

  // Ensure the export button is hidden initially
  const exportButton = document.querySelector(".btn-wishlist-export");
  if (exportButton) {
    exportButton.classList.add("hidden");
  }
});

document.addEventListener("product-grid:replaced", () => {
  initButtons();
});

document.addEventListener("page-contents:updated", () => {
  initButtons();
});

document.addEventListener("cart-upsell:updated", () => {
  initButtons();
});

document.addEventListener("predictive-search:updated", () => {
  initButtons();
});

const productRecommendations = document.querySelector(selectors.productRecommendation);
if (productRecommendations) {
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length > 0) {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          if (mutation.addedNodes[i].nodeType === Node.ELEMENT_NODE) {
            if (mutation.addedNodes[i].classList.contains("ProductListWrapper")) {
              initButtons();
              window.yotpoWidgetsContainer?.initWidgets();
            }
          }
        }
      }
    });
  });

  const config = {
    childList: true,
    subtree: true,
  };
  observer.observe(productRecommendations, config);
}

document.addEventListener("shopify-wishlist:updated", async (event) => {
  if (CUSTOMER_LOGGED_IN) {
    updateMergedWishlist();
  }
  initGrid();
});

const getProductIdfromHandle = async (handle) => {
  try {
    const res = await fetch(`/products/${handle}.json`);
    const data = await res.json();
    const productId = data.product.id;
    return `gid://shopify/Product/${productId}`;
  } catch (error) {
    return console.error("[Wishlist] Failed to fetch product id", error);
  }
};

const updateMergedWishlist = async () => {
  // merge localstorage and customer metafield
  // add missing products to customer metafield and localstorage

  const localStorageWishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  let localWishlist = [];
  if (localStorageWishlist) {
    if (localStorageWishlist.includes(LOCAL_STORAGE_DELIMITER)) {
      localWishlist = localStorageWishlist.split(LOCAL_STORAGE_DELIMITER);
    } else {
      localWishlist = localStorageWishlist.split();
    }
  }

  const livewishlist = (await await fetchWishlist()) || [];

  const mergedWishlist = [...new Set([...localWishlist, ...livewishlist])];

  if (mergedWishlist) {
    mergedWishlist.forEach(async (handle) => {
      const liveWishlistActive = livewishlist.includes(handle);
      if (!liveWishlistActive) {
        const gid = await getProductIdfromHandle(handle);
        await updateWishlistFromFetch(gid);
      }

      const localWishlistActive = localWishlist.includes(handle);
      if (!localWishlistActive) {
        updateWishlistOnLocal(localWishlist, handle);
        let wishlist = await getWishlist();
        reInitButtons(handle, wishlist);
      }
    });
  }
};

const fetchProductCardHTML = async (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  let pageURL = window.location.href;

  try {
    const res = await fetch(productTileTemplateUrl);
    const res_2 = await res.text();
    const text = res_2;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, "text/html");
    if (pageURL.includes("account")) {
      const productImageLink = htmlDocument.documentElement.querySelector(
        selectors.productCardImageWrapper
      );
      return productImageLink.outerHTML;
    } else {
      const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
      return productCard.outerHTML;
    }
  } catch (err) {
    return console.error(`[Wishlist] Failed to load content for handle: ${handle}`, err);
  }
};

const setupGrid = async (grid) => {
  const wishlist = await getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);

  const wishlistGrid = document.querySelector(selectors.wishlistContent);
  const wishlistEmpty = document.querySelector(selectors.wishlistEmpty);
  const wishlistText = document.querySelector(selectors.wishlistText);

  document.querySelectorAll(".wishlist-promo-blocks .promo-block-card").forEach((promoblock) => {
    const promoIndex = promoblock.dataset.index - 1;
    if (responses.length > promoIndex) responses.splice(promoIndex, 0, promoblock.outerHTML);
  });

  const wishlistProductCards = responses.join("");

  if (wishlistProductCards) {
    wishlistEmpty.classList.add("hidden");
    if (wishlistText) wishlistText.classList.remove("hidden");
    wishlistGrid.innerHTML = wishlistProductCards;
  } else {
    wishlistEmpty.classList.remove("hidden");
    if (wishlistText) wishlistText.classList.add("hidden");
    wishlistGrid.innerHTML = "";
  }
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent("shopify-wishlist:init-product-grid", {
    detail: { wishlist: wishlist },
  });
  document.dispatchEvent(event);
};

const setupButtons = async (buttons, reInit = false, wishlist = []) => {
  buttons.forEach(async (button) => {
    button.setAttribute("data-initialized", "");
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) {
      return console.error(
        "[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
      );
    }

    const wishlistActive = wishlist.includes(productHandle);
    button.classList.toggle(BUTTON_ACTIVE_CLASS, wishlistActive);

    if (!reInit) {
      button.addEventListener("click", async () => {
        await updateWishlist(productHandle);
      });
    }
  });

  const event = new CustomEvent("shopify-wishlist:setup-buttons-run", {
    detail: { wishlist: wishlist },
  });
  document.dispatchEvent(event);
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) {
    setupGrid(grid);
  }
};

export const initButtons = async () => {
  const wishlist = await getWishlist();
  const buttons = document.querySelectorAll(selectors.buttonNotInitialized) || [];
  if (buttons.length) {
    setupButtons(buttons, false, wishlist);
  } else {
    return;
  }
  const event = new CustomEvent("shopify-wishlist:init-buttons", {
    detail: { wishlist: wishlist },
  });
  document.dispatchEvent(event);
};

const reInitButtons = async (handle, updatedWishlist) => {
  let buttons;
  buttons = document.querySelectorAll(`[data-product-handle="${handle}"]`) || [];
  if (buttons.length) {
    setupButtons(buttons, true, updatedWishlist);
  } else {
    return;
  }
};

const fetchWishlist = async () => {
  try {
    const res = await fetch(ALL_WISHLIST_URL);
    const data = await res.json();
    const products = data.metafield?.value;
    return products;
  } catch (error) {
    return console.error("[Wishlist] Failed to fetch wishlist", error);
  }
};

const getWishlist = async () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) {
    return wishlist.split(LOCAL_STORAGE_DELIMITER);
  } else {
    return [];
  }
};

const updateWishlistFromFetch = async (gid) => {
  try {
    const res = await fetch(UPDATE_WISHLIST_URL, {
      method: "POST",
      body: gid,
    });
    const data = await res.json();
    const products = data.metafield.value;
    return products;
  } catch (error) {
    return console.error("[Wishlist] Failed to update wishlist", error);
  }
};

const updateWishlistOnLocal = (wishlist = [], handle) => {
  if (handle) {
    const indexInWishlist = wishlist.indexOf(handle);
    if (indexInWishlist === -1) {
      wishlist.push(handle);
    } else {
      wishlist.splice(indexInWishlist, 1);
    }
  }

  const wishlistString = wishlist.join(LOCAL_STORAGE_DELIMITER);

  if (wishlist.length) {
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlistString);
  } else {
    localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  }
};

const updateWishlist = async (handle, disableEvent = false) => {
  let wishlist = await getWishlist();
  updateWishlistOnLocal(wishlist, handle);
  reInitButtons(handle, wishlist);

  if (CUSTOMER_LOGGED_IN) {
    const gid = await getProductIdfromHandle(handle);
    await updateWishlistFromFetch(gid);
    wishlist = await getWishlist();
  }
  if (!disableEvent) {
    const event = new CustomEvent("shopify-wishlist:updated", {
      detail: { wishlist: wishlist },
    });
    document.dispatchEvent(event);
  }
};

const updateHeaderIcon = async () => {
  const localStorageWishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  let localWishlist = [];
  if (localStorageWishlist) {
    if (localStorageWishlist.includes(LOCAL_STORAGE_DELIMITER)) {
      localWishlist = localStorageWishlist.split(LOCAL_STORAGE_DELIMITER);
    } else {
      localWishlist = localStorageWishlist.split();
    }
  }

  if (localWishlist.length) {
    document.body.classList.add("wishlist-is-active");
  } else {
    document.body.classList.remove("wishlist-is-active");
  }
};

document.addEventListener("shopify-wishlist:setup-buttons-run", updateHeaderIcon);

const exportWishlistAsExcel = async () => {
  const exportButton = document.querySelector(".btn-wishlist-export");
  disableButton(exportButton);

  try {
    const wishlistGrid = document.querySelector(".wishlist__grid");
    
    const allProductItems = document.querySelectorAll(".wishlist__grid .ProductItem");
    
    const productGridItems = [...document.querySelectorAll(".wishlist__grid .ProductItem")].filter(
      (item) => item.style.display !== "none"
    );

    if (!productGridItems.length) {
      
      enableButton(exportButton);
      return;
    }

    const exportUrl = "https://saysky-backend-222804631241.europe-west1.run.app/api/utils/excel/download";
    const data = { rows: [] };

    productGridItems.forEach((product, productIndex) => {
      const id = product.dataset.productId;
      
      const variants = window.ALL_VARIANTS.filter((variant) => variant.product_id == id);
      
      if (!variants || variants.length === 0) {
        return;
      }

      // Use the first variant as a representative for product-level fields
      const rep = variants[0];

      const productSku = rep.sku?.split("\\")[0]?.trim() || "";

      // Process tags for dip and drop (if available)
      let dropTag = "";
      let dipTag = "";
      if (rep.tags) {
        const tags = rep.tags.split(",");
        dropTag = tags.find((tag) => tag.includes("drop_"))?.replace("drop_", "").trim() || "";
        dipTag = tags.find((tag) => tag.includes("b2b_dip"))?.replace("b2b_dip-", "").trim() || "";
      }

      // Process colors
      let colors = "";
      if (rep.colors) {
        colors = rep.colors.toLowerCase();
        colors = colors
          .split(" ")
          .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
          .join(" ");
      }

      let delivery = "";
      if (rep.delivery) {
        delivery = rep.delivery.join(", ");
      }

      let color_code = "";
      if (rep.color_code) {
        color_code = rep.color_code;
      }

      // Process genders
      let genders = "";
      if (rep.genders) {
        const gendersArray = rep.genders
          .split(",")
          .map((g) => {
            const lowerG = g.toLowerCase();
            switch (lowerG) {
              case "male":
              case "men":
                return "Men";
              case "female":
              case "women":
                return "Women";
              case "unisex":
                return "Unisex";
              default:
                return null;
            }
          })
          .filter((g) => g !== null);
        genders = gendersArray.join(", ");
      }

      // Determine picture URL
      let imageSrc = "";
      if (rep.image && !rep.image.includes("no-image")) {
        imageSrc = rep.variant_image;
      } else {
        imageSrc = rep.product_image;
      }
      if (imageSrc && !imageSrc.includes("http")) {
        imageSrc = `https:${imageSrc}`;
      }

      // Other common fields
      const uniqueId = id;
      const name = rep.title;
      const type = rep.type;
      const price = rep.price_money;

      // Gather distinct sizes from variants (assuming variant.option1 is the size)
      const sizes = [...new Set(variants.map((v) => v.option1))];

      // Build header row for this product
      let headerRow = {
        column1: "picture",
        column2: "uniqueId",
        column3: "name",
        column4: "gender",
        column5: "type",
        column6: "colorDesc",
        column7: "colorCode",
        column8: "dip",
        column9: "delivery",
        column10: "price (RRP)",
        column11: "totalItems",
      };

      sizes.forEach((size, index) => {
        headerRow[`column${12 + index}`] = size;
      });

      // Build product data row for this product
      let dataRow = {
        column1: imageSrc,
        column2: productSku,
        column3: name,
        column4: genders,
        column5: type,
        column6: colors,
        column7: color_code,
        column8: dipTag,
        column9: delivery,
        column10: price,
        column11: sizes.length,
      };

      sizes.forEach((size, index) => {
        dataRow[`column${12 + index}`] = 1;
      });

      // Push both rows
      data.rows.push(headerRow);
      data.rows.push(dataRow);

      console.log("pushing")
    });

    console.log("data rows", data)

    if (data.rows.length == 0) {
      alert("No products to export - no valid data generated, please try again in a few seconds");
      disableButton(exportButton);
      return;
    }

    const res = await fetch(exportUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });


    if (!res.ok) {
      throw new Error(`Export API returned ${res.status}: ${res.statusText}`);
    }

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
    window.URL.revokeObjectURL(url);
    
  } catch (error) {
    console.error("Export error:", error);
    alert(`Export failed: ${error.message}`);
  } finally {
    enableButton(exportButton);
  }
};



function disableButton(button) {
  button.disabled = true;
  button.classList.add("loading");
  button.innerHTML = "Exporting...";
}

function enableButton(button) {
  button.disabled = false;
  button.classList.remove("loading");
  button.innerHTML = "Export list";
}

document.addEventListener("ALL_VARIANTS:loaded", () => {
  const exportButtonSelector = ".btn-wishlist-export";
  const exportButton = document.querySelector(exportButtonSelector);

  if (exportButton) {
    exportButton.classList.remove("hidden"); // Show the export button
    exportButton.addEventListener("click", exportWishlistAsExcel);
  }
});